import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initGoogleAnalytics } from "./analytics";
import App from "./App";
import "./styles.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root was not found.");
}

initGoogleAnalytics();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
